import React, { useState } from "react";
import { Input, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";

const FlOrderDeductionsFilter = ({
  onSearch,
  onCancel,
  filtersList,
}) => {

  const { isMobile } = useIsMobile();
  const currentMonth = dayjs().format("MM");
  const currentYear = dayjs().format("YYYY");

  const [filters, setFilters] = useState({
    key: "",
    fl_name: "",
    month: currentMonth,
    year: currentYear,
  });

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => {
      if (key === "month" && !prevFilters.year) {
        // if user selects month but year is empty, set year automatically
        return {
          ...prevFilters,
          [key]: value,
          year: currentYear,
        };
      }
      return {
        ...prevFilters,
        [key]: value,
      };
    });
  };
  

  const handleSearch = () => {
    const updatedFilters = {
      ...filters,
      year: filters?.year, // if year is empty, use currentYear
    };
    onSearch(updatedFilters);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleCancel = async () => {
    setFilters({ key: "", fl_name: "", month: "", year: "" });
    await onCancel();
  };

  const renderFilter = (filter) => {
    switch (filter) {

      case "month":
        return (
          <Select
            placeholder="Select Month"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.month || undefined}
            onChange={(value) => handleFilterChange("month", value)}
            onKeyDown={handleKeyDown}
            >
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((month, index) => (
              <Select.Option
                key={index + 1}
                value={String(index + 1).padStart(2, "0")}>
                {month}
              </Select.Option>
            ))}
          </Select>
        );

      case "year":
        return (
          <Select
            placeholder="Select Year"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.year||undefined}
            onChange={(value) => handleFilterChange("year", value)}
            onKeyDown={handleKeyDown}
            >
            {[...Array(11)].map((_, i) => (
              <Select.Option
                key={currentYear - 5 + i}
                value={String(currentYear - 5 + i)}>
                {currentYear - 5 + i}
              </Select.Option>
            ))}
          </Select>
        );

      default:
        return (
          <Input
            placeholder={
              filter === "fl_name" ? "Filter by FL Name" : `Filter by ${filter}`
            }
            style={{ width: 300 }}
            value={filters[filter] || ""}
            onChange={(e) => handleFilterChange(filter, e.target.value)}
            onKeyDown={handleKeyDown}
          />
        );
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{ background: "#eceff1", padding: "20px", borderRadius: "8px" }}>
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}>
          {filtersList.map((filter) => (
            <div key={filter} style={{ marginRight: 16 }}>
              {renderFilter(filter)}
            </div>
          ))}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginRight: isMobile ? 0 : "12px",
              justifyContent: "space-between",
              width: "auto",
            }}>
            <Button
              type="primary"
              style={{ width: 140, background: "#040724" }}
              icon={<SearchOutlined />}
              onClick={handleSearch}>
              Search
            </Button>
            <Button
              style={{ width: 140 }}
              type="default"
              onClick={handleCancel}>
              Reset
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlOrderDeductionsFilter;
